import PropTypes from "prop-types";
import React from "react";
import "./TitleField.css"; // #region HOOK

/**
 * Représente un titre de niveau "1"
 * @class
 * @category Fields
 * @param {Fields.TitleField.propTypes} props Les propriétés du composant
 */

function TitleField(props) {
  // Récupération des props
  var color = props.color,
      margeTop = props.margeTop,
      size = props.size,
      text = props.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "TitleField-Container",
    style: {
      color: color,
      marginTop: margeTop ? "10px" : "0px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      fontSize: size
    }
  }, text));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link TitleField}
 * @typedef {Object} TitleField.propTypes
 * @property {string} text Le titre
 * @property {string} [color=#000] La couleur du titre
 * @property {string} [size=1.8em] La taille du titre
 * @property {boolean} [margeTop=false] true pour avoir une marge de 10px au dessus, sinon 0px
 */


TitleField.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  margeTop: PropTypes.bool
} : {};
/*
  Valeurs par défaut des propriétés
*/

TitleField.defaultProps = {
  color: "#000",
  size: "1.8em",
  margeTop: false
}; // #endregion

export { TitleField };